import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseInvoiceAdjustmentDeliveryDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.delivery-date.earlier-than-adjusted');
    }
}
